import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import {
  BusinessIntelligenceCountModel,
  BusinessIntelligenceLclStatsModel,
  BusinessIntelligenceMarineInsuranceStatsModel,
  BusinessIntelligencePeriodModel,
  BusinessIntelligenceProductModel,
  ManagementSearchBusinessIntelligenceModel,
} from '@data-layer/models/management';

@Injectable({
  providedIn: 'root',
})
export class BusinessIntelligenceRepository {
  constructor(private apiService: ApiService) {}

  public getESPeriods(
    params: ManagementSearchBusinessIntelligenceModel,
    isShowLoader: boolean = false,
  ): Observable<BusinessIntelligencePeriodModel[]> {
    return this.apiService.get<BusinessIntelligencePeriodModel[]>(
      `${environment.url.businessIntelligence}entry-summaries/periods`,
      { params },
      {
        isShowLoader,
      },
    );
  }

  public getISFPeriods(
    params: ManagementSearchBusinessIntelligenceModel,
    isShowLoader: boolean = false,
  ): Observable<BusinessIntelligencePeriodModel[]> {
    return this.apiService.get<BusinessIntelligencePeriodModel[]>(
      `${environment.url.businessIntelligence}isfs/periods`,
      { params },
      {
        isShowLoader,
      },
    );
  }

  public getUsersPeriods(
    params: ManagementSearchBusinessIntelligenceModel,
    isShowLoader: boolean = false,
  ): Observable<BusinessIntelligencePeriodModel[]> {
    return this.apiService.get<BusinessIntelligencePeriodModel[]>(
      `${environment.url.businessIntelligence}users/periods`,
      { params },
      {
        isShowLoader,
      },
    );
  }

  public getCompaniesPeriods(
    params: ManagementSearchBusinessIntelligenceModel,
    isShowLoader: boolean = false,
  ): Observable<BusinessIntelligencePeriodModel[]> {
    return this.apiService.get<BusinessIntelligencePeriodModel[]>(
      `${environment.url.businessIntelligence}companies/periods`,
      { params },
      {
        isShowLoader,
      },
    );
  }

  public getCompaniesPaid(
    params: ManagementSearchBusinessIntelligenceModel,
    isShowLoader: boolean = false,
  ): Observable<BusinessIntelligenceCountModel> {
    return this.apiService.get<BusinessIntelligenceCountModel>(
      `${environment.url.businessIntelligence}companies/paid`,
      { params },
      {
        isShowLoader,
      },
    );
  }

  public getCompaniesFirstPaidPeriods(
    params: ManagementSearchBusinessIntelligenceModel,
    isShowLoader: boolean = false,
  ): Observable<BusinessIntelligencePeriodModel[]> {
    return this.apiService.get<BusinessIntelligencePeriodModel[]>(
      `${environment.url.businessIntelligence}companies/first-paid/periods`,
      { params },
      {
        isShowLoader,
      },
    );
  }

  public getBillsPeriods(
    params: ManagementSearchBusinessIntelligenceModel,
    isShowLoader: boolean = false,
  ): Observable<BusinessIntelligencePeriodModel[]> {
    return this.apiService.get<BusinessIntelligencePeriodModel[]>(
      `${environment.url.businessIntelligence}bills/periods`,
      { params },
      {
        isShowLoader,
      },
    );
  }

  public getBillsProducts(
    params: ManagementSearchBusinessIntelligenceModel,
    isShowLoader: boolean = false,
  ): Observable<BusinessIntelligenceProductModel[]> {
    return this.apiService.get<BusinessIntelligenceProductModel[]>(
      `${environment.url.businessIntelligence}bills/products`,
      { params },
      {
        isShowLoader,
      },
    );
  }

  public getFreightAggregations(
    params: ManagementSearchBusinessIntelligenceModel,
    isShowLoader: boolean = false,
  ): Observable<BusinessIntelligenceLclStatsModel> {
    return this.apiService.get<BusinessIntelligenceLclStatsModel>(
      `${environment.url.businessIntelligence}freight-aggregations`,
      { params },
      {
        isShowLoader,
      },
    );
  }

  public getFreightQuotesByPeriod(
    params: ManagementSearchBusinessIntelligenceModel,
    isShowLoader: boolean = false,
  ): Observable<BusinessIntelligencePeriodModel[]> {
    return this.apiService.get<BusinessIntelligencePeriodModel[]>(
      `${environment.url.businessIntelligence}freight-quotes/periods`,
      { params },
      {
        isShowLoader,
      },
    );
  }

  public getFreightShipmentsByPeriod(
    params: ManagementSearchBusinessIntelligenceModel,
    isShowLoader: boolean = false,
  ): Observable<BusinessIntelligencePeriodModel[]> {
    return this.apiService.get<BusinessIntelligencePeriodModel[]>(
      `${environment.url.businessIntelligence}freight-shipments/periods`,
      { params },
      {
        isShowLoader,
      },
    );
  }

  public getFreightManualQuotesByPeriod(
    params: ManagementSearchBusinessIntelligenceModel,
    isShowLoader: boolean = false,
  ): Observable<BusinessIntelligencePeriodModel[]> {
    return this.apiService.get<BusinessIntelligencePeriodModel[]>(
      `${environment.url.businessIntelligence}freight-manual-quotes/periods`,
      { params },
      {
        isShowLoader,
      },
    );
  }

  public getMarineInsuranceByPeriod(
    params: ManagementSearchBusinessIntelligenceModel,
    isShowLoader: boolean = false,
  ): Observable<BusinessIntelligencePeriodModel[]> {
    return this.apiService.get<BusinessIntelligencePeriodModel[]>(
      `${environment.url.businessIntelligence}marine-insurance/periods`,
      { params },
      {
        isShowLoader,
      },
    );
  }

  public getMarineInsuranceAggregations(
    params: ManagementSearchBusinessIntelligenceModel,
    isShowLoader: boolean = false,
  ): Observable<BusinessIntelligenceMarineInsuranceStatsModel> {
    return this.apiService.get<BusinessIntelligenceMarineInsuranceStatsModel>(
      `${environment.url.businessIntelligence}marine-insurance-aggregations`,
      { params },
      {
        isShowLoader,
      },
    );
  }
}
